module.exports = __webpack_public_path__ + "01c766bf055cae5e077b6a788f6e8cd9.svg";


//////////////////
// WEBPACK FOOTER
// ../images/sponsors/flipkart.svg
// module id = 405
// module chunks = 0